import { useEffect, useState } from "react";
import { MESSAGE } from '../../../utils/message';
import {
  DonationsSection,
  DonationsTitle,
  DonationsTotal,
  TotalTileSpan,
  DonationsFoundation,
  FoundationText,
  FoundationAmount,
  FoundationTitle,
  FoundationDate,
  TotalTile,
  Downloadatebtn,
  Giveagain,
  CheckTitle,

} from './myDonationsStyle'
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { myDonationHandler } from "../../../redux/slices/myAccount/myDonation-slice";
import 'react-dates/lib/css/_datepicker.css';
import SimpleLoader from "../simpleLoader/Loader";
import "react-dates/initialize"
import { DownloadReportBtn } from "../nonprofitDonations/nonprofitDonationsStyle";
import { Button } from "react-bootstrap";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { addCartDonateHandler } from "../../../redux/slices/donationCamp/addCartDonate-slice";
import { useNavigate } from "react-router-dom";
import { AccountBlue, AccountText } from "../manageAccountTab/manageAccountStyle";
import { accountDetailHandler } from "../../../redux/slices/myAccount/accountDetail-slice";
import { sendEmailForVerification } from "../../../redux/slices/myAccount/sendVerificationMail";

// import { DateRangePicker, FocusedInputShape } from 'react-dates';

const MyDonations = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const myDonations = useSelector((state: any) => state?.myDonation?.data);
  const accountDetail = useSelector((state: any) => state?.accountDetail);
  const errorMessage = useSelector((state: any) => state?.myDonation?.message)


  const [selectedDonations, setSelectedDonations] = useState<string[]>([]);

  const user_id = typeof localStorage !== "undefined" && localStorage.getItem("userId")
  const [startDate, setStartDate] = useState<number | null>(moment().utc().startOf("month").valueOf());
  const [endDate, setEndDate] = useState<number | null>(moment().endOf("month").valueOf());

  const [focusedInput, setFocusedInput] = useState<any>(null);
  const [ReactDates, setReactDates] = useState<any>(null);

  const handleCheckboxChange = (donationId: string) => {


    setSelectedDonations(prevState => {
      if (prevState.includes(donationId)) {
        return prevState.filter(id => id !== donationId); // Unselect
      } else {
        return [...prevState, donationId]; // Select
      }
    });
  };

  useEffect(() => {
    if (user_id) {
      dispatch(accountDetailHandler(user_id));
    }
  }, []);

  const handleDatesChange = ({ startDate, endDate }: any) => {
    setStartDate(startDate ? startDate.valueOf() : null);
    setEndDate(endDate ? endDate.valueOf() : null);
    setLoader(true);
  };

  useEffect(() => {
    let body;

    if (startDate && endDate) {
      body = {
        start_date: moment(startDate).toISOString(),
        end_date: moment(endDate).endOf("day").toISOString(),
      };
    }
    if (user_id) {
      setLoader(true);
      dispatch(myDonationHandler(user_id, body))
        .then(() => setLoader(false))
        .catch(() => setLoader(false));
    }
  }, [startDate, endDate, user_id, dispatch]);

  const handleGiveAgain = (donation: any) => {

    const data = {
      org_id: donation?.nonprofit?.id,
      amount: donation?.amount,
    };

    if (data.org_id && data.amount > 0) {
      dispatch(addCartDonateHandler(data)).then(() => {
        navigate("/donate-now");
      });
    }
  };

  const handleAddBasket = (donations: any[]) => {
    const donationsData: any = donations.map(donation => ({
      org_id: donation?.nonprofit?.id,
      amount: donation?.amount,
    }));

    if (donationsData.length > 0) {
      // Dispatch the addCartDonateHandler with multiple donations at once
      dispatch(addCartDonateHandler(donationsData)).then(() => {
        navigate("/donate-now");
      });
    }
  };

  //   useEffect(() => {
  //     import('react-dates').then((module) => {
  //       setReactDates(module);
  //     });
  // }, []);
  const downloadPdf = () => {
    const doc = new jsPDF();
    // Add title
    doc.setFontSize(18);
    doc.text("Donations Report", 14, 15);

    // Check if transactions exist
    if (myDonations?.transactions?.length) {
      // Define table columns
      const tableColumn = ["Transaction ID", "Date", "Nonprofit", "Currency", "Amount"];
      const tableRows: any[] = [];

      // Populate table rows
      myDonations.transactions.forEach((donation: any) => {
        const rowData = [
          donation?.tx_id || "-",

          donation?.date ? moment(donation?.date).format("MMM D, YYYY") : "-",
          donation?.nonprofit?.title || "-",
          donation?.currency ? donation?.currency : "-",
          donation?.amount
        ];
        tableRows.push(rowData);
      });

      // Add total row
      const totalRow = ["", "", "Total", "", `$${myDonations?.total || 0}`];
      tableRows.push(totalRow);

      // Generate table
      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: 25, // Adjust to avoid overlapping title
      });

      // Save the PDF
      doc.save("Donations_Report.pdf");
    } else {
      alert("No donations found to generate a report.");
    }
  };

  useEffect(() => {

    import('react-dates').then((module) => {

      setReactDates({
        DateRangePicker: module.DateRangePicker,
      });
    });
  }, []);

  if (!ReactDates) {
    return null; // Return null until the module is loaded
  }

  const { DateRangePicker } = ReactDates;

  const handleSendMail = () => {
    const userId = accountDetail?.data?.user_id
    const domain = window.location.origin;

    if (accountDetail) {
      dispatch(sendEmailForVerification({ email: accountDetail?.data?.email, link: `${domain}/verify_email/${userId}/` }))
    }
  }


  return (
    <>
      {errorMessage ? <AccountBlue>
        <AccountText>You must verify your email address in order to be able to receive email from GreatNonprofits.
        </AccountText>
        <Button onClick={(e) => { e.preventDefault(); handleSendMail() }} className="btn bg-transparent border-0 p-0 m-0 outline-none"
          onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
          onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
        >Re-send verification email</Button>
      </AccountBlue> :
        <DonationsSection>
          <DonationsTitle>{MESSAGE.myDonations}</DonationsTitle>
          <DonationsTotal>
            <TotalTile>Total: <TotalTileSpan>${myDonations?.total}</TotalTileSpan></TotalTile>
            <Downloadatebtn>
              <DownloadReportBtn><Button className='report-btn' onClick={downloadPdf}>{MESSAGE.downloadReport}</Button></DownloadReportBtn>
              <DateRangePicker
                startDate={startDate ? moment(startDate) : null}
                startDateId="your_unique_start_date_id"
                endDate={endDate ? moment(endDate) : null}
                endDateId="your_unique_end_date_id"
                onDatesChange={handleDatesChange}
                focusedInput={focusedInput}
                onFocusChange={(focusedInput: any) => setFocusedInput(focusedInput)}
                isOutsideRange={() => false}
                displayFormat="YYYY/MM/DD"
              />
            </Downloadatebtn>
          </DonationsTotal>
          {loader ? (
            <SimpleLoader />
          ) : (
            myDonations?.transactions.length ? (
              myDonations?.transactions.map((donation: any, index: number) => (
                <DonationsFoundation key={index + 1}>
                  <FoundationText>
                    <CheckTitle>
                      <input
                        type="checkbox"
                        checked={selectedDonations.includes(donation.id)}
                        onChange={() => handleCheckboxChange(donation.id)}
                      />
                      <FoundationTitle>{donation.nonprofit?.title}</FoundationTitle>
                    </CheckTitle>
                    <FoundationDate>
                      {donation?.date
                        ? moment(donation?.date).format("MMM D, YYYY")
                        : "-"}
                    </FoundationDate>
                    <Giveagain>
                      <Button className='give-btn' onClick={() => handleGiveAgain(donation)}>{MESSAGE.giveagain}</Button>
                    </Giveagain>
                  </FoundationText>
                  <FoundationAmount>
                    {donation?.currency ?? "$"} ${donation?.amount}
                  </FoundationAmount>
                </DonationsFoundation>
              ))
            ) : (
              <div>No donations found for the selected date range.</div>
            )

          )}
          {myDonations?.transactions.length &&
            <div>
              <DownloadReportBtn> <Button className='report-btn' onClick={() => {
                const donationsToAdd = selectedDonations.map((donationId) => {
                  return myDonations?.transactions.find((d: any) => d.id === donationId);
                }).filter(donation => donation); // filter out any undefined donations

                // Pass all selected donations at once
                if (donationsToAdd.length > 0) {
                  handleAddBasket(donationsToAdd); // Now passing the array of donations
                }
              }}>Add Selected Nonprofits to Basket</Button></DownloadReportBtn>
            </div>
          }

        </DonationsSection>
      }
    </>
  );
};

export default MyDonations;